import OnboardingWrapper from './OnboardingWrapper';

export default OnboardingWrapper;
